import React from 'react';
import '../../../assets/css/edittags.css';
export default function FormView(props) {
  const {
    width,
    height,
    title,
    show,
    setShow,
    saveDisabled,
    children,
    saveTitle
  } = props;
  const hidePopup = (e) => {
    if (e.target.className === 'form-container')
      setShow(false);
  }
  
  return (
    <>
      {show && (
        <div className='form-container' onClick={(e) => hidePopup(e)}>
          <div className='form-display' style={{ width: width, height: height }}>
            <div className='action-title'>
              {title}
              <button type="button" class="close-btn" aria-label="Close" onClick={() => setShow(false)}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className='form-dataEntry'>
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
